import { useGetThemes } from 'src/hooks';
import { handleConfigUpdates } from 'src/utils/changeHandler';

import { FormSelectorProps } from './FormSelector.interface';

export const useFormSelectorState = (props: FormSelectorProps) => {
  const handleComponentChanges = (
    data: any,
    path: string | string[],
    value: any | any[],
    keysToRemove: Array<string> = [],
  ) => {
    const updatedFormData = handleConfigUpdates(
      data,
      path,
      value,
      keysToRemove,
    );

    // set the form data
    props.setConfig(updatedFormData);
  };

  return {
    handleComponentChanges,
  };
};

export const useThemeOptions = () => {
  const { data: themes } = useGetThemes();

  return (
    themes?.map((theme) => {
      return { label: theme.name, value: theme.id };
    }) ?? []
  );
};

export const useGetTheme = (themeId?: number) => {
  const { data: themes } = useGetThemes();

  return themes?.find((theme) => theme.id === themeId);
};
